import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/emr-country";

export const getAllCountry = () => axios.get(API_PATH + "/get-all-country");

export const pagingCountry = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getCountryById = (countryId) => axios.get(API_PATH + "/getbyid/" + countryId);

export const saveCountry = country => axios.post(API_PATH + '/save', country);
 
export const deleteCountry = countryId => axios.delete(API_PATH + '/mark-delete/' + countryId)
